import { useEffect } from "react";
import "../styles/Contents.css";

export default function Terms() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">
      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Terms & Conditions</h1>
        <p>
          Please read these terms and conditions carefully before using our
          website and services.
        </p>
      </section>

      {/* TERMS CONTENT */}
      <section className="about-sectio reveal-left">
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using our website, you agree to be bound by these
          Terms & Conditions. If you do not agree, please do not use our
          services.
        </p>
      </section>

      <section className="about-sectio reveal-right">
        <h2>2. Educational Services</h2>
        <p>
          ACCESS provides tuition programs, stay & study facilities, test
          series, and study materials. All services are subject to availability
          and institutional guidelines.
        </p>
      </section>

      <section className="about-sectio reveal-left">
        <h2>3. User Responsibilities</h2>
        <p>
          Users must provide accurate information during registration and
          enquiries. Any misuse of content, impersonation, or disruptive
          behavior may result in denial of services.
        </p>
      </section>

      <section className="about-sectio reveal-right">
        <h2>4. Fees & Payments</h2>
        <p>
          All fees once paid are non-refundable unless explicitly stated.
          Payment schedules, discounts, and offers are subject to change
          without prior notice.
        </p>
      </section>

      <section className="about-sectio reveal-left">
        <h2>5. Intellectual Property</h2>
        <p>
          All content, study materials, logos, and designs on this website are
          the intellectual property of ACCESS. Unauthorized copying or
          distribution is strictly prohibited.
        </p>
      </section>

      <section className="about-sectio reveal-right">
        <h2>6. Limitation of Liability</h2>
        <p>
          ACCESS shall not be held responsible for any direct or indirect
          damages arising from the use of our services or website.
        </p>
      </section>

      <section className="about-sectio reveal-left">
        <h2>7. Changes to Terms</h2>
        <p>
          We reserve the right to update or modify these Terms & Conditions at
          any time. Continued use of the website implies acceptance of the
          updated terms.
        </p>
      </section>

      {/* FOOTER NOTE */}
      <section className="about-footer reveal">
        <p>
          For any questions regarding these Terms & Conditions, please contact
          us directly. We are committed to transparency and fairness.
        </p>
      </section>
    </div>
  );
}
